import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./ContactUsFormModal.module.scss";
import ContactUsForm from "../ContactUsForm/ContactUsForm";

const ContactUsFormModal = ({ open, onClose }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button> */}
        <ContactUsForm
          customText="Ingredient"
          noSection={true}
          onClose={onClose}
        />
      </div>
    </div>,
    document.body
  );
};

export default ContactUsFormModal;
